import { useState } from "react";
import styles from "./Testimonial.module.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import SectionHeader from "shared/components/Header/SectionHeader";
import { useFetch } from "shared/utils/useFetch";
import { trackTestimonialView } from "shared/services/analytics";

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { data: testimonials } = useFetch("/api/testimonials", []);

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const activeTestimonial = testimonials[currentIndex];

  const showPreviousTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const showNextTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <SectionHeader title="What People Say About My Work" />
        <div className={styles.controls}>
          <button
            type="button"
            aria-label="Show previous testimonial"
            onClick={showPreviousTestimonial}
            className={styles.navButton}
          >
            <FaArrowLeft />
          </button>
          <button
            type="button"
            aria-label="Show next testimonial"
            onClick={showNextTestimonial}
            className={styles.navButton}
          >
            <FaArrowRight />
          </button>
        </div>

        <a
          href={activeTestimonial.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.testimonialCard}
          onClick={() => trackTestimonialView(activeTestimonial.author)}
        >
          <div className={styles.infoContainer}>
            {activeTestimonial.photo && activeTestimonial.photo.includes(".svg") ? (
              <img
                className={styles.svgAvatar}
                src={activeTestimonial.photo}
                alt={activeTestimonial.author}
              />
            ) : (
              <img
                src={activeTestimonial.photo}
                alt={activeTestimonial.author}
                className={styles.avatar}
              />
            )}
            <div className={styles.infoText}>
              <h3 className={styles.name}>{activeTestimonial.author}</h3>
              <p className={styles.role}>{activeTestimonial.role}</p>
            </div>
          </div>
          <p className={styles.quote}>{activeTestimonial.description}</p>
        </a>
      </div>
    </div>
  );
};

export default Testimonial;
